import type { AiUsageInput } from "./types.js";

/** Prefer runtime id (`usedModel` / `modelUsed`); fall back to `model`. */
export function resolveUsageModel(input: AiUsageInput): string {
  const value = input.usedModel ?? input.modelUsed ?? input.model;
  if (!value?.trim()) {
    throw new Error(
      "[ai-tools] Cost calculation requires `usedModel`, `modelUsed`, or `model` on usage input.",
    );
  }
  return value.trim();
}
